module.exports = __webpack_public_path__ + "img/2_206.ea9d849c.png";